






























































































import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import RuleAliasSummary from '@/domain/rule/entity/rule-alias-summary.entity';
import RuleService from '@/domain/rule/service/rule.service';
import MainButton from '@/shared/buttons/main-button.component.vue';
import Rules from '@/shared/rules/rules';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';

@Component({ components: { LabelSlot, MainButton } })

export default class RuleConfiguration extends Vue {
  @Prop() businessUnitId!: string;

  rules: RuleAliasSummary[] = [];

  ruleAlias: any[] = [];

  selectedRule: RuleAliasSummary = RuleAliasSummary.of({});

  actualRuleName = '';

  valid: boolean = false;

  validationRules: Rules = new Rules();

  created() {
    this.getRuleAlias();
  }

  @Watch('businessUnitId')
  getRuleAlias() {
    RuleService.getBusinessUnitRuleAlias(this.businessUnitId)
      .then((response: any) => {
        this.rules = RuleAliasSummary.ofList(response);
        this.ruleAlias = this.rules.map(this.buildItemRule)
      })
  }

  buildItemRule(rule: RuleAliasSummary): object {
    return {
      ruleId: rule.ruleId,
      name: rule.alias,
    }
  }

  selectRule(rule: any) {
    this.selectedRule = RuleAliasSummary.of(
      this.rules.find((el: RuleAliasSummary) => el.ruleId === rule.ruleId),
    );
  }

  hasSelection(): boolean {
    return this.selectedRule.ruleId !== '';
  }

  saveRuleAlias() {
    RuleService.saveRuleAlias(this.businessUnitId, this.selectedRule)
      .then((response: any) => {
        VbSnackbarService.showSuccess('Configuração salva com sucesso');
        this.getRuleAlias();
        this.selectedRule = RuleAliasSummary.of({});
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err))
  }
}

